import __request__ from "routing/request";
export function getMetrics(JSONbody, requestOptions) {
  return __request__("POST", "/streams/metrics", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
